import { render } from "./LateralMenu.vue?vue&type=template&id=b8b35cfc&scoped=true"
import script from "./LateralMenu.vue?vue&type=script&lang=js"
export * from "./LateralMenu.vue?vue&type=script&lang=js"

import "./LateralMenu.vue?vue&type=style&index=0&id=b8b35cfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b35cfc"]])

export default __exports__